<template>
  <el-dialog title="微信扫码" :visible.sync="visible" width="400px">
    <div ref="qrcode" class="qrcode"></div>
    <div class="qrcode-tip">微信扫码进入移动端商城</div>
  </el-dialog>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      visible: false,
    }
  },
  methods: {
    showQrcode(url) {
      const self = this
      this.visible = true
      this.$nextTick(() => {
        self.$refs.qrcode.innerHTML = "";
        self.rqcode = new QRCode(self.$refs.qrcode, {
          width: 144,
          height: 144, // 高度
          text: url
        });
      })
    }
  }
}
</script>

<style scoped>
.qrcode {
  width: 144px;
  height: 144px;
  margin: 0 auto;
}
.qrcode-tip {
  line-height: 40px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-top: 20px;
}
</style>